import { apolloClient } from '../apolloClient'
import { implementDataInBankSlip } from './getUrlAndBarcodeBankSlip'
import { GET_BANK_SLIP_NOTIFICATION } from './queries/GET_BANK_SLIP_NOTIFICATION'
import { Installment } from './updateBankSlip'

export const getUrlAndBarcodeBankSlipIfExist = async (installment: Installment) => {
  const { receivableBillId: billReceivableId, installmentId } = installment
  const input = { billReceivableId, installmentId: installmentId.toString() }

  const response = await apolloClient.query({
    query: GET_BANK_SLIP_NOTIFICATION,
    variables: { input },
  })

  if (response?.data?.getBankSlipNotification?.urlReport) {
    return implementDataInBankSlip(response, installment)
  }
}
